import http from "@services/httpService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"

/**
 * Feature-0204 — CHỈ ĐỌC. Backend đã bỏ 5 method ghi của `PinkBookFeeUpdateAppService`; phí trước bạ
 * (RGF) và phí hành chính / hạn đợt cấp sổ hồng (ADF) nay đi qua 2 loại ContractEvent
 * `RegistrationFee` / `PinkBookDueDate` để có quy trình duyệt. Bảng cũ giữ lại để tra cứu.
 */
class PinkBookFeeUpdateService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/PinkBookFeeUpdate/GetAll",
      { params }
    )
    return res.data.result
  }

  public async getAllContractOverview(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/PinkBookFeeUpdate/GetAllContractOverview",
      { params }
    )
    return res.data.result
  }
}

export default new PinkBookFeeUpdateService()
